<template>
  <v-card class="platter elevation-0 custom-border-top py-6 px-6 fromBottom fast">
      <!-- v-if="!showAnswer" -->
    <QuizAnswers
      v-model="selected"
      :answers="answers"
      :place="question.place"
      :showAnswer="showAnswer"
      @select="select"
    />

    <QuizAnswerResult
      v-if="showAnswer"
      :question="question"
      @next="$emit('next')"
    />
  </v-card>
</template>

<style scoped>
.platter {
  background-color: white;
  /* border-radius: 13px 13px 0 0; */
  border-radius: 0px;
  height: 100%;
  /* max-height: 550px; */
}
@media (min-width: 700px) {
  .platter {
    border-radius: 12px 12px 0 0;
    box-shadow: 0px 4px 24px -8px rgba(0, 0, 0, 0.16) !important;
  }
}
</style>

<script>
import QuizAnswers from '@/components/games/quiz/QuizAnswers.vue';
import QuizAnswerResult from '@/components/games/quiz/QuizAnswerResult.vue';

export default {
  name: 'QuizPlatter',
  components: {
    QuizAnswers,
    QuizAnswerResult,
  },
  props: {
    question: {
      type: Object,
      default: () => ({}),
    },
    showAnswer: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  data: () => ({
    selected: -1,
  }),
  computed: {
    answers() {
      return [...this.question.answers];
    },
  },
  methods: {
    select(i) {
      if (this.selected !== -1) {
        return false;
      }
      this.selected = i;
      this.$emit('select', i);
      return true;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.selected = this.value;
      },
    },
  },
};
</script>
